import script from "./ValueCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValueCard.vue?vue&type=script&setup=true&lang=ts"

import "./ValueCard.vue?vue&type=style&index=0&id=84b65ce2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b65ce2"]])

export default __exports__